<template>
  <div>
    <div class="flex">
      <div class="mr-4">
        <drop-zone
          key='pdfEn'
          :text="`Upload English PDF`"
          :accept="`application/pdf`"
          :displayAs="'attachment'"
          :value="form.pdfEn"
          :presigned-url="presignedUrl"
          @input="onPdfEnSuccessUploaded"
        />
        <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
      </div>

      <div class="mr-4">
        <drop-zone
          key='pdfZh'
          :text="`Upload Chinese PDF`"
          :accept="`application/pdf`"
          :displayAs="'attachment'"
          :value="form.pdfZh"
          :presigned-url="presignedUrl"
          @input="onPdfZhSuccessUploaded"
        />
        <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
      </div>
      <div>
        <drop-zone
          key='xml'
          :text="`Upload XML`"
          :accept="`application/xml`"
          :displayAs="'attachment'"
          :value="form.xml"
          :presigned-url="presignedUrl"
          @input="onXmlSuccessUploaded"
        />
        <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
      </div>
    </div>

    <vs-button @click="handleSubmit" class="mt-4">
      Upload
    </vs-button>
  </div>
</template>


<script>
import DropZone from '@/components/DropZone';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    DropZone,
  },
  props: {
    profileId: {
      type: String,
      require: true,
    },
    pdfEn: {
      type: String,
      require: false,
    },
    pdfZh: {
      type: String,
      require: false,
    },
    xml: {
      type: String,
      require: false,
    },
  },
  data() {
    return {
      form: {
        pdfEn: null,
        pdfZh: null,
        xml: '',
      },
    };
  },
  computed: {
    presignedUrl() {
      return `/admin/dna/user-profiles/${this.profileId}/report-upload`;
    },
    ...mapState({
      uploadHelloDnaReportState: ({ helloDnaProfile }) => helloDnaProfile.apiState.uploadHelloDnaReport,
    }),
  },
  methods: {
    ...mapActions({
      uploadHelloDnaReport: 'helloDnaProfile/uploadHelloDnaReport',
    }),
    async handleSubmit() {
      const isValid = this.form.xml;

      if (isValid) {
        return this.submit();
      }

      return this.$vs.dialog({
        color: 'danger',
        title: `Validation Error!`,
        text: 'Please upload report in both PDF and XML format',
      });
    },
    onPdfEnSuccessUploaded(file) {
      this.form.pdfEn = file ? file.fileUrl : null;
    },
    onPdfZhSuccessUploaded(file) {
      this.form.pdfZh = file ? file.fileUrl : null;
    },
    onXmlSuccessUploaded(file) {
      this.form.xml = file ? file.fileUrl : null;
    },
    async submit() {
      return this.$vs.dialog({
        color: 'primary',
        title: `Are you sure submit?`,
        text: 'Continue submit',
        acceptText: 'Yes',
        accept: () => {
          const body = {
            reportXmlUrl: this.form.xml,
            ...(this.form.pdfEn && { reportPdfFileUrlEn: this.form.pdfEn }),
            ...(this.form.pdfZh && { reportPdfFileUrlZh: this.form.pdfZh }),
          };

          return this.uploadHelloDnaReport({
            id: this.profileId,
            body,
          });
        },
      });
    },
  },
  watch: {
    pdfEn(value) {
      this.form.pdfEn = value;
    },
    pdfZh(value) {
      this.form.pdfZh = value;
    },
    xml(value) {
      this.form.xml = value;
    },
    'uploadHelloDnaReportState.loading'(value) {
      if (value) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    'uploadHelloDnaReportState.success'(value) {
      this.$vs.loading.close();
      if (value) {
        this.$emit('upload-success');

        this.$vs.notify({
          title: 'Successful upload!',
          color: 'success',
          position: 'top-center',
        });
      }
    },
    'uploadHelloDnaReportState.error'(error) {
      this.$vs.loading.close();
      if (error) {
        this.$vs.notify({
          title: 'Error!',
          text: error.data.message,
          color: 'danger',
          position: 'top-center',
        });
      }
    },
  },
};
</script>
